module.exports = __webpack_public_path__ + "media/src/images/features-02-353969e5614d20f63b0e961fae3af92d.svg";